import React, { Component } from 'react';
import Grid from '../../Utils/GridFiltro';
import PropTypes from 'prop-types';
import { standardActions } from '../../Utils/GridFiltro/StandardActions';
import NavbarModulo from '../../components/NavbarModulo';

class PresupuestoList extends Component{
    static propTypes = {
        data: PropTypes.object.isRequired,
        loader: PropTypes.bool.isRequired,
        onSortChange: PropTypes.func,
    };

    static defaultProps = {
        loading: true
    };

    componentDidMount = () => {
        const { listar, getModulo } = this.props;
        let ruta = window.location.href;
        let periodo = ruta.split('/');
        getModulo(periodo[5],periodo[4]);
        listar();
    }
    render(){
        const { data, loader, periodoD, modulo, imprimirPresupuesto, eliminarPresupuesto } = this.props;
        let ruta = window.location.href;
        let datos = ruta.split('/');
        return(
            <React.Fragment>
                <NavbarModulo
                    periodoD = {periodoD}
                    modulo = {modulo}
                />
                <br />
                <h3 className="p-2 bg-secondary title">Presupuestos</h3>
                <br />
                <div className="d-flex flex-row justify-content-start mb-2">
                    <a
                        href={`/#/gestion_proyecto/${datos[5]}/presupuesto/crear`}
                        className='btn btn-primary'
                    >
                        Crear presupuesto
                    </a>
                </div>
                
                <Grid 
                    hover 
                    striped 
                    data={data} 
                    loading={loader} 
                    headerStyle={ { background: 'black' } } 
                    //onPageChange={onPageChange}
                    //onSortChange={onSortChange} 
                >
                    <TableHeaderColumn
                        isKey
                        width="100"
                        dataField="numero"
                        headerAlign="center"
                        dataAlign='right'
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Numero
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="500"
                        dataField="nombreProyecto"
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Proyecto
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="total_quetzales"
                        width="200"
                        headerAlign="center"
                        dataAlign='right'
                        dataFormat={(cell, row)=>{
                            if (parseFloat(cell) === 0.00){
                                return ''
                            }else{
                                return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(cell);    
                            }
                        }}
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Total (Q)
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        width="200"
                        dataField="total_dolares"
                        headerAlign="center"
                        dataAlign='right'
                        dataFormat={(cell, row)=>{
                            if (parseFloat(cell) === 0.00){
                                return ''
                            }else{
                                return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(cell);    
                            }
                        }}
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Total (USD)
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        thStyle={
                        {color: 'white'}}
                        dataField="id"
                        width="100"
                        dataAlign="center"
                        dataSort
                        dataFormat={standardActions({ 
                            ver: "presupuesto",
                            editar: "presupuesto",
                            imprimir: imprimirPresupuesto,
                            empresa: datos[5],
                            periodo: datos[7],
                            modulo: datos[4],
                        })} 
                    >
                        Acciones
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        thStyle={
                        {color: 'white'}}
                        dataField="id"
                        width="100"
                        dataAlign="center"
                        dataSort
                        dataFormat={standardActions({
                            eliminarPresupuestoGP: eliminarPresupuesto,
                            empresa: datos[5],
                            periodo: datos[7],
                            modulo: datos[4],
                        })} 
                    >
                        Borrar
                    </TableHeaderColumn>
                </Grid>
            </React.Fragment>
        );
    }
}

export default PresupuestoList;
